module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText,
      "rows-per-page-items": _vm.rowsPerPageItems,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.deceased_location_of_wake))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.plan ? props.item.plan.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_end ? props.item.wake_end : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "justify-left layout px-0"
        }, [(!_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [(_vm.detailCaseButtonActionIsDefault) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetail(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailCaseButtonActionIsGoToCheckListsTab) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetailCheckListsTab(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.detailCaseButtonActionIsGoToInvoicesTab) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goCasesDetailInvoicesTab(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "indigo"
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v("\n          View details\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.$can('send', 'cases-client-email') && !_vm.crewSelecting) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": "",
            "disabled": _vm.disabled.sendReceiptToClient
          },
          on: {
            "click": function($event) {
              return _vm.sendReceiptToClient(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("mail")])], 1), _vm._v("\n          Send receipt\n        ")], 1) : _vm._e(), _vm._v(" "), _c('ConfirmationDialog', {
          ref: "confirm"
        })], 1)]
      }
    }])
  }), _vm._v(" "), (!_vm.loadingInProgress) ? _c('v-layout', {
    staticClass: "mt-4"
  }, [_c('v-flex', {
    staticClass: "text-sm-center"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.total
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.current),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "current", $$v)
      },
      expression: "pagination.current"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('AppEditCasesDialog'), _vm._v(" "), _c('CrewDialog'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d803d134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/BillingCases.vue
// module id = 1029
// module chunks = 1